import { createSlice } from '@reduxjs/toolkit'
import { selectCom0204 } from 'app/core/services/com/com.service'
import { RootState } from 'app/core/store'
import { comUtil } from 'app/shared/utils'

interface Auth {
    token: string | null
}

const initialState = {
    token: null,
} as Auth

const slice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: () => {},
        logout: () => {
            clearData()
        },
        setToken: (state, { payload }) => {
            state.token = payload
        },
        clearData: (state) => {
            state.token = null
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(selectCom0204.matchFulfilled, (state, action) => {
            comUtil.setUserData('tkn', action.payload.pageAuthKey)
            //API가 성공하면 가로채 넣는다.
            return { token: action.payload.pageAuthKey }
        })
    },
})

export const { login, logout, setToken, clearData } = slice.actions

export default slice.reducer
